import React from "react";
import {useSelector} from "react-redux";
import {selectBirthAdoption} from "../../../selectors/birthAdoption";
import {CustomQLECard} from "../../custom-common";
import {QLE_STATUS} from "../../../constants/qle";
import {formatDate} from "../../../utils/utils";
import STRATEGIC_PARTNER from "../../../constants/strategicPartners";
import {getQLECardType, getQLEStatus} from "../../../utils/qle";

export const BirthAdoptionCard = () => {
	const birthAdoptionInfo = useSelector(selectBirthAdoption);
	const {
		autoApproveDate,
		declineCoverage,
		openEnrollmentStartDate,
		openEnrollmentEndDate,
		dateOfBirth,
		changeExplanationCopy,
		coverageEffectiveDate,
		decisionDate,
		status,
		tier,
		coveredMembers,
		willBePendingForApproval,
	} = birthAdoptionInfo;

	const cardType = getQLECardType(willBePendingForApproval, status, decisionDate);
	const qleStatus = getQLEStatus(willBePendingForApproval, status, decisionDate);
	const { CONTACT_SUPPORT: { NUMBER } } = STRATEGIC_PARTNER;

	const renderDescription = () => {
		if(declineCoverage) return <i>The free period for this child has ended and chose to not continue coverage.<br/>
			Coverage for child declined.</i>;
		const descriptions = {
			[QLE_STATUS.PENDING_FOR_APPROVAL]: `This change impacts historical coverage and requires carrier approval before it can be processed. If you have any questions, please reach out to ${STRATEGIC_PARTNER.CONTACT_SUPPORT.NUMBER}.`,
			[QLE_STATUS.COMPLETED]: `${changeExplanationCopy ? `${changeExplanationCopy}. ` : ''}If you have any questions, please reach out to ${STRATEGIC_PARTNER.CONTACT_SUPPORT.NUMBER}.`,
			[QLE_STATUS.REJECTED]: (
				<>
					<span>There are no coverage changes as a result of this event.</span><br/>
					{changeExplanationCopy ? (
						<span>
                      		{`${changeExplanationCopy}. `}
                    	</span>
					) : null}
					If you have any questions, please reach out to {NUMBER}.
				</>
			),
			[QLE_STATUS.DEFAULT]: 'This change has an impact to coverage, see details below.'
		};
		return <i>{descriptions[qleStatus] || descriptions[QLE_STATUS.DEFAULT]}</i>;
	};

	const renderChangeRequestLanguage = () => {
		if(autoApproveDate) return null;
		const formattedDecisionDate = decisionDate && formatDate(decisionDate, decisionDate, 'MMM Do, YYYY');
		if (qleStatus === QLE_STATUS.PENDING_FOR_APPROVAL) return `Pending carrier approval.`;
		if (qleStatus === QLE_STATUS.COMPLETED) return `Approved on ${formattedDecisionDate}.`;
		if (qleStatus === QLE_STATUS.REJECTED) return `Denied on ${formattedDecisionDate}.`;
		return null;
	}

	const getFooterContent = () => {
		const footerData = [];
		footerData.push({
			title: 'Birth Date:',
			value: formatDate(dateOfBirth, dateOfBirth, "MMM Do, YYYY")
		})
		footerData.push({
			title: 'Enrollment Dates:',
			value: `${formatDate(openEnrollmentStartDate, openEnrollmentStartDate, "MMM Do, YYYY")} - ${formatDate(openEnrollmentEndDate, openEnrollmentEndDate, "MMM Do, YYYY")}`
		})

		if(!declineCoverage && qleStatus !== QLE_STATUS.REJECTED){
			footerData.push({
				title: `${tier} coverage begins on:`,
				value: formatDate(coverageEffectiveDate, coverageEffectiveDate, "MMM Do, YYYY")
			})
		}
		return footerData;
	}

	const getFooterContentEnd = () =>
		!(declineCoverage || qleStatus === QLE_STATUS.REJECTED) && coveredMembers?.length
			? { title: 'Covered members', value: coveredMembers.join(', ') }
			: null;

	return (
		<CustomQLECard
			qleStatus={qleStatus}
			cardType={cardType}
			qleName={"Birth/Adoption"}
			changeRequest={renderChangeRequestLanguage()}
			description={renderDescription()}
			footerData={getFooterContent()}
			footerBottomSection={getFooterContentEnd()}
		/>
	)
}